import { createAction, props } from '@ngrx/store'
import { NotificationType } from '@adex/shared/models/inside-models/notification'


export const loadNotifications = createAction(
  '[Notifications] Load Notifications'
)

export const setNotifications = createAction(
  '[Notifications] Set Notifications',
  props<{ data: NotificationType[] }>()
)

export const createNotification = createAction(
  '[Notifications] Create Notification',
  props<{ data: NotificationType }>()
)

export const editNotification = createAction(
  '[Notifications] Edit Notification',
  props<{ data: NotificationType }>()
)

export const deleteNotification = createAction(
  '[Notifications] Delete Notification',
  props<{ id: number }>()
)

